<template class="currencydropdownWrap">
  <div
    v-if="isPermission('currency.list')"
    class="currency-dropdown top-filters"
  >
    <v-select
      v-model="selectedCurrency"
      filled
      dense
      :label="$t('currency')"
      :items="currencyOptions"
      item-value="code"
      item-text="code"
      @focus="toggleDropdown(true)"
      @blur="toggleDropdown(false)"
      @change="setCurrency"
    />
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      selectedCurrency: "PKR",
      currencyOptions: [
        { code: "USD", name: "United States Dollar", symbol: "$" },
        { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
      ],
    };
  },
  computed: {
    getSelected() {
      return localStorage.getItem("selectedCurrency");
    },
  },
  mounted() {
    if (this.isPermission("currency.list") == false) {
      localStorage.setItem("selectedCurrency", "PKR");
      this.selectedCurrency = "PKR";
    } else if (!this.getSelected) {
      this.setCurrency("PKR");
      this.selectedCurrency = "PKR";
    } else {
      this.selectedCurrency = this.getSelected;
    }
  },
  methods: {
    isPermission(val) {
      return this.$admin.can(val);
    },
    setCurrency(val) {
      localStorage.setItem("selectedCurrency", val);
      const { name, params, query } = this.$route;
      if (JSON.stringify(params) !== JSON.stringify({})) {
        this.$router.push({ name: name, params, query });
      } else {
        this.$router.push({ name: name });
      }
      window.location.reload();
    },
    toggleDropdown(isOpen) {
      this.$emit("toggle-header-class", isOpen);
    },
  },
};
</script>
<style lang="sass" scoped>
.currency-dropdown
    width: 6.9rem
    padding-top:1.8rem
</style>
